import assert from 'assert-ts';
import {Concept} from 'types';
import type {SchemaReference} from 'schemas/types';
import {isSubTypeOfEntity} from 'services/utils/functions/isSubTypeOfEntity';
import type {MergeSuggestionDto} from '../types';

export const mapMergeSuggestionType = (
  schemaRef: SchemaReference,
): MergeSuggestionDto['type'] => {
  if (typeof schemaRef !== 'string') {
    if (isSubTypeOfEntity(schemaRef.subType, Concept.collection)) {
      return 'SERIES';
    }

    if (schemaRef.entity === Concept.collection) {
      return 'SERIES';
    }

    if (isSubTypeOfEntity(schemaRef.subType, Concept.agent)) {
      return 'AGENT';
    }

    if (schemaRef.entity === Concept.agent) {
      return 'AGENT';
    }
  }

  if (schemaRef === Concept.work) {
    return 'WORK';
  }

  assert(
    false,
    'mapMergeSuggestionType: Expected valid MergeSuggestionDto.type',
  );
};
